import React, { useContext, useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  makeStyles,
  TextField,
  Button,
  IconButton,
  useMediaQuery,
} from '@material-ui/core'
import { ArrowDropUp, ArrowDropDown, TheatersRounded } from '@material-ui/icons'

import InriverImage from '../../../core/components/InriverImage'
import TranslationLabel from '../../../core/components/TranslationLabel'
import priceDtoHelper from '../../../shared/PriceDtoHelper'
import StockItem from './StockItem'

import { ProductsContext } from '../context/ProductsContext'
import { CoreContext } from '../../../core/context/CoreContext'

import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'

const useStyles = makeStyles((theme) => ({
  tableRoot: {
    display: 'grid',
    gridAutoRows: 'auto',
    gridTemplateColumns:
      'min-content auto min-content min-content min-content min-content min-content',
    gridTemplateRows: 'min-content',
    gap: '0px 0px',
    alignItems: 'center',
  },
  tableHeaderCell: {
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    textAlign: 'left',
    padding: '5px 20px',
  },
  tableCell: {
    position: 'relative',
    padding: '5px 20px',
    whiteSpace: 'nowrap',
  },
  tableCellPicture: {
    position: 'relative',
    padding: '5px 5px 5px 5px',
    whiteSpace: 'nowrap',
  },
  tableCellProduct: {
    position: 'relative',
    padding: '5px 5px 5px 5px',
    whiteSpace: 'nowrap',
  },
  tableCellSalesUnit: {
    position: 'relative',
    padding: '5px 5px 5px 5px',
    whiteSpace: 'nowrap',
  },
  tableCellPrice: {
    position: 'relative',
    padding: '5px 15px 5px 5px',
    whiteSpace: 'nowrap',
  },
  tableCellQuantity: {
    borderLeft: '1px solid #eee',
  },
  tableCellLast: {
    padding: '0 20px 0 0',
    marginLeft: 5,
  },
  arrowContainer: {
    borderLeft: '1px solid #eee',
    padding: '0 5px 0 5px',
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    display: 'block',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  label: {
    textTransform: 'uppercase',
    fontSize: 11,
    backgroundColor: 'rgba(255, 255, 255, .6)',
    color: theme.palette.grey[600],
    position: 'static',
    marginRight: 15,
    padding: 0,
  },
  small: {
    fontSize: 13,
  },
  listStock: {
    display: 'inline-block',
    marginLeft: 15,
    transform: 'translateY(-1px)',
  },
  listOpenOrders: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  listReservations: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  quantity: {
    'width': '64px',

    '& input': {
      textAlign: 'center',
    },
    // Target Chrome, Safari, Edge
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      'margin': 0,
    },
    // Target Firefox
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
  btn: {
    'color': 'white',
    'backgroundColor': 'black',
    'flexGrow': 1,
    'height': 40,

    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
  },
  priceNormal: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: 'block',
  },
  priceText: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: 'inline-block',
    marginLeft: 10,
  },
  currency: {
    position: 'absolute',
    top: '-16px',
    left: '62px',
    color: theme.palette.grey[600],
    fontSize: 12,
  },
  priceYours: {
    fontSize: 16,
    fontWeight: 'bold',
    display: 'inline-block',
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  quantityOptionsHeader: {
    display: 'block',
    marginRight: '15px',
  },
  quantityOptionsCell: {
    display: 'block',
    whiteSpace: 'nowrap',
  },
  quantityOptions: {
    display: 'flex',
    fontWeight: '400',
    lineHeight: '1.5',
    letterSpacing: '0.00938em',
    padding: '5px 0',
    fontSize: '13px',
  },
  campaignIdLink: {
    display: 'block',
    marginRight: '15px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))

export default function TableView(props) {
  const classes = useStyles()

  const { enableProductLink = true } = props

  if (!props.products) {
    return <></>
  }

  return (
    <div className={classes.tableRoot}>
      {!props.hideHeader && (
        <>
          <div style={{ borderBottom: 'none', gridColumn: '1 / -1' }}></div>
          <div
            className={classes.tableHeaderCell}
            style={{ paddingRight: 0 }}></div>
          <div className={classes.tableHeaderCell}>
            <TranslationLabel name='productListNoAndName' />
          </div>
          <div className={classes.tableHeaderCell}>
            {' '}
            {/* CampaignHeader */}{' '}
          </div>
          <div className={classes.tableHeaderCell}>
            <TranslationLabel name='productListSalesUnits' />
          </div>
          <div
            className={classes.tableHeaderCell}
            style={{ textAlign: 'right' }}>
            <TranslationLabel name='productListPrice' />
          </div>
          <div className={classes.tableHeaderCell}>
            <TranslationLabel name='productListQuantity' />
          </div>
          <div className={classes.tableHeaderCell}></div>
        </>
      )}

      {props.products.map((product, i) => (
        <Cell
          key={product.productNo}
          product={product}
          classes={classes}
          enableProductLink={enableProductLink}
          {...props}
        />
      ))}
    </div>
  )
}

const Cell = (props) => {
  //The product state below is not used, but through the update/setProduct a rerender is caused when needed
  const [product, setProduct] = useState({ ...props.product })

  const options = {
    ...props,
    update: setProduct,
  }

  return (
    <>
      <RenderCellDetails {...options} />
      <RenderCellCampaignDetails {...options} />
      <RenderCellSalesUnitDetails {...options} />
      <RenderCellPrice {...options} />
      <RenderCellQuantity {...options} />
      <RenderCellActionButtons {...options} />
    </>
  )
}

const RenderCellActionButtons = (props) => {
  return (
    <div
      className={props.classes.tableCellLast}
      style={props.hideDetailed ? { paddingRight: 0 } : {}}>
      {props.addToBasket && (
        <Button
          disabled={
            priceDtoHelper.hasNoPrice(props.product) || props.disabledBuyButton
          }
          variant='contained'
          disableElevation
          className={props.classes.btn}
          onClick={() => props.addToBasket(props.product)}>
          <AddIcon />
        </Button>
      )}

      {props.remove && (
        <Button
          variant='contained'
          className={props.classes.btn}
          onClick={() => props.remove(props.product.productNo)}>
          <DeleteIcon />
        </Button>
      )}
    </div>
  )
}

const RenderCellQuantity = (props) => {
  const inputRef = useRef(null)

  const { EmptyStartQuantity, ShowSelected, ExcelOrderImport } = props

  useEffect(() => {
    if (EmptyStartQuantity && !ShowSelected) {
      handleChangeQuantity({
        target: {
          value: 0,
        },
      })
    }
    //Set quantity to lowest campaign Quantity if exists, if not imported from excel
    if (!ExcelOrderImport)
      props.product.quantity = priceDtoHelper.getCampaignQuantity(props.product)
    //If in excelimport secure that quantity is matching multiplum etc.
    if (ExcelOrderImport)
      props.product.quantity = priceDtoHelper.findNextAllowedQuantity(props.product,props.product.quantity)
  }, [])


  useEffect(() => {
    if (!props.product.quantity) {
      return
    }

    if (props.product.quantity <= 0) {
      handleChangeQuantity({
        target: {
          //Backend always secure at least 1 in value
          value: props.product.minimumQuantity,
        },
      })
    }
  }, [props.product])

  const onBlurHandler = (e) => {
    props.product.quantity = priceDtoHelper.findNextAllowedQuantity(
      props.product,
      e.target.value,
    )

    props.update({ ...props.product })
  }

  const handleChangeQuantity = (e) => {
    const val = e.target.value
    props.product.quantity = val

    if (props.onQuantityChange) {
      const allowedQuantity = priceDtoHelper.findNextAllowedQuantity(
        props.product,
        e.target.value,
      )
      props.onQuantityChange(props.product.productNo, allowedQuantity)
    }

    //This ends up with a setProduct that update state and rerenders the component
    props.update({ ...props.product })
  }

  const incrementQuantity = () => {
    const currentQuantity = props.product.quantity
    const newQuantity = priceDtoHelper.GetNextIncrementQuantity(
      props.product,
      currentQuantity,
    )
    handleChangeQuantity({
      target: {
        value: newQuantity,
      },
    })
  }

  const decrementQuantity = () => {
    const currentQuantity = props.product.quantity

    const newQuantity = priceDtoHelper.GetNextDecrementQuantity(
      props.product,
      currentQuantity,
    )

    if (newQuantity >= props.product.minimumQuantity) {
      handleChangeQuantity({
        target: {
          value: newQuantity,
        },
      })
    }
  }

  return (
    <div
      className={props.classes.tableCellQuantity}
      style={{ display: 'flex', alignItems: 'center' }}>
      {/* Arrow buttons container (stacked vertically) */}
      <div
        className={props.classes.tableCellArrow}
        style={{ display: 'flex', flexDirection: 'column' }}>
        {/* Increment Button */}
        <IconButton
          size='small'
          onClick={incrementQuantity}>
          <ArrowDropUp />
        </IconButton>

        {/* Decrement Button */}
        <IconButton
          size='small'
          onClick={decrementQuantity}
          disabled={props.product.quantity <= props.product.minimumQuantity}>
          <ArrowDropDown />
        </IconButton>
      </div>

      {/* Quantity Input */}
      <TextField
        onBlur={onBlurHandler}
        size='small'
        type='number'
        value={props.product.quantity || 0}
        onChange={handleChangeQuantity}
        className={props.classes.quantity}
        inputRef={inputRef}
        onClick={() => {
          inputRef.current.select(0, -1)
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowUp') {
            e.preventDefault()
            incrementQuantity()
          }
          if (e.key === 'ArrowDown') {
            e.preventDefault()
            decrementQuantity()
          }
        }}
        label={<TranslationLabel name='numberOf' />}
        variant='outlined'
      />
    </div>
  )
}

const RenderCellPrice = (props) => {
  const currentPrice = priceDtoHelper.findPrice(
    props.product.quantity || props.product.colli,
    props.product,
  )

  return (
    <div
      className={props.classes.tableCellPrice}
      style={{ textAlign: 'right' }}>
      {!props.showRetailPrice && (
        <>
          {priceDtoHelper.hasDiscount(currentPrice) && (
            <del className={props.classes.priceNormal}>
              {currentPrice.grossPrice}
            </del>
          )}

          {(currentPrice.priceType === priceDtoHelper.priceEnum.Campaign || currentPrice.priceType === priceDtoHelper.priceEnum.Archive) && (
            <del className={props.classes.priceNormal}>
              {currentPrice.grossPrice}
            </del>
          )}

          <span className={props.classes.priceYours}>
            {currentPrice.netPrice}
          </span>
        </>
      )}

      {props.showRetailPrice && (
        <span className={props.classes.priceYours}>
          {props.product.recommendedRetailPrice}
        </span>
      )}
    </div>
  )
}

const RenderCellSalesUnitDetails = (props) => {
  const { product, classes, hideDetailed } = props
  const standardPrice = product.priceDtos.find(
    (e) => e.priceType === priceDtoHelper.priceEnum.Standard,
  )

  return (
    <div
      className={classes.tableCellSalesUnit}
      style={hideDetailed ? { paddingLeft: 0 } : {}}>
      {/* Split Colli Quantity */}
      {standardPrice &&
        product.colli !== 1 &&
        product.minimumQuantity < product.colli && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TranslationLabel name='splitColliQuantity' />
            <span>
              1-{product.colli - 1}
              <TranslationLabel name='productsUnit' />
            </span>
          </div>
        )}

      {/* Price Dtos Mapping */}
      {product.priceDtos.map((price, i) => {
        let label, color

        if (
          price.priceType === priceDtoHelper.priceEnum.Standard &&
          price.priceValidFromQuantity === product.colli
        ) {
          label = <TranslationLabel name='salesColliQuantity' />
          color = null
        } else if (price.priceType === priceDtoHelper.priceEnum.Campaign) {
          label = <TranslationLabel name='campaignPrice' />
          color = 'green'
        } else if (price.priceType === priceDtoHelper.priceEnum.Archive) {
          label = <TranslationLabel name='ArchivePrice' />
          color = 'red'
        } else {
          return null // Skip if none of the conditions match
        }

        return (
          <div
            key={i}
            style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span
              className={classes.quantityOptionsHeader}
              style={{ color }}>
              {label}
            </span>
            <span>
              {price.priceValidFromQuantity}
              <TranslationLabel name='productsUnit' />
            </span>
          </div>
        )
      })}

      {/* Brownbox Information */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TranslationLabel name='Brownbox' />
        <span>
          {product.brownBox.numberOfItemsInBox}
          <TranslationLabel name='productsUnit' />
        </span>
      </div>
    </div>
  )
}

const RenderCellCampaignDetails = (props) => {
  const coreCtx = useContext(CoreContext)

  const handleClick = () => {
    coreCtx.history.push(`/sales/campaign/${props.product.campaignId}`)
  }

  return (
    <>
      <div>
        {props.product.campaignId?.length > 0 && (
          <div onClick={handleClick}>
            <span
              className={props.classes.campaignIdLink}
              style={{ color: 'green' }}>
              {props.product.campaignId}
            </span>
          </div>
        )}
      </div>
    </>
  )
}

const RenderCellDetails = (props) => {
  const productsModel = useContext(ProductsContext)

  const isMdOrBelow = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const splitProductDescription = (text, maxLength = 50) => {
    // If the viewport doesn't match or the description is short, return it as is
    if (!isMdOrBelow || text.length <= maxLength) return text

    let line1, line2, line3

    // Find the last space before 50 characters
    const firstPart = text.slice(0, 50)
    const firstPartLastSpaceIndex = firstPart.lastIndexOf(' ')

    if (firstPartLastSpaceIndex === -1) {
      // If no space exists within the first 50 characters
      line1 = text.slice(0, 50) // Take the first 50 characters as line1 and stop there
    } else {
      // Line 1: Up to the last space before 50 characters
      line1 = text.slice(0, firstPartLastSpaceIndex)

      // Remaining text after line 1
      const remainingTextAfterLine1 = text.slice(firstPartLastSpaceIndex + 1)

      if (remainingTextAfterLine1.length < 50) {
        line2 = remainingTextAfterLine1
      } else {
        // Line 2: Next 50 characters or up to the next logical break
        const secondPart = remainingTextAfterLine1.slice(0, 50)
        const secondSpaceIndex = secondPart.lastIndexOf(' ')

        if (secondSpaceIndex !== -1) {
          // If there's a space within the 50 characters, use it as the end of line 2
          line2 = remainingTextAfterLine1.slice(0, secondSpaceIndex)
          line3 = remainingTextAfterLine1.slice(secondSpaceIndex + 1)
        } else {
          // If no space, take 50 characters as line 2
          line2 = remainingTextAfterLine1.slice(0, 50)
          line3 = remainingTextAfterLine1.slice(50)
        }

        // Line 3: Limit to a maximum of 50 characters
        if (line3.length > 50) {
          line3 = line3.slice(0, 50) // Truncate after 50 characters
        }
      }
    }
    // Return a JSX fragment with three lines
    return (
      <>
        <span>{line1}</span>
        <br />
        <span>{line2}</span>
        <br />
        <span>{line3}</span>
      </>
    )
  }

  return (
    <>
      {!props.hideDetailed && (
        <>
          <div
            style={{
              borderBottom: '1px solid #eee',
              gridColumn: '1 / -1',
            }}></div>
          <div
            className={props.classes.tableCellPicture}
            style={{ paddingRight: 0 }}>
            <div
              style={{ width: '77px', height: '55px', position: 'relative' }}>
              <div
                style={{
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                }}>
                {props.enableProductLink ? (
                  <Link
                    to={`/sales/products/item/${props.product.productNo}`}
                    onClick={productsModel.gotoProduct}
                    className={props.classes.imgWrapperInner}
                    style={{
                      display: 'flex',
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                    <InriverImage
                      className={props.classes.img}
                      productNo={props.product.productNo}
                      alt={props.product.description}
                      displayConfig='SalesSite_SmallThumbnail'
                      showImage={props.product.showImage}
                    />
                  </Link>
                ) : (
                  <div
                    className={props.classes.imgWrapperInner}
                    style={{
                      display: 'flex',
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                    <InriverImage
                      className={props.classes.img}
                      productNo={props.product.productNo}
                      alt={props.product.description}
                      displayConfig='SalesSite_SmallThumbnail'
                      showImage={props.product.showImage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={props.classes.tableCellProduct}>
            {props.enableProductLink ? (
              <Link
                to={`/sales/products/item/${props.product.productNo}`}
                className={`${props.classes.title}`}
                onClick={productsModel.gotoProduct}>
                {splitProductDescription(props.product.description)}
              </Link>
            ) : (
              <span className={`${props.classes.title}`}>
                {splitProductDescription(props.product.description)}
              </span>
            )}

            <span className={`${props.classes.label}`}>
              {props.product.brandNo}
            </span>

            <span className={props.classes.small}>
              <TranslationLabel name='productNumber' />
              <span> {props.product.productNo}</span>
            </span>

            <div className={props.classes.listStock}>
              <StockItem
                text={props.product.inventoryText}
                status={props.product.inventoryStatus}
              />
            </div>

            {/* Open Orders and Reservations Modal Triggers - horizontal layout */}
            {(props.product.openOrders?.length > 0 || props.product.reservations?.length > 0) && (
              <div style={{ display: 'flex', gap: '16px', marginTop: 4 }}>
                {props.product.openOrders?.length > 0 && (
                  <div
                    onClick={() =>
                      props.setOpenOrdersModal(props.product.productNo)
                    }>
                    <span className={props.classes.listOpenOrders}>
                      <TranslationLabel name='openOrders' />
                    </span>
                  </div>
                )}
                {props.product.reservations?.length > 0 && (
                  <div
                    onClick={() =>
                      props.setReservationsModal(props.product.productNo)
                    }>
                    <span className={props.classes.listReservations}>
                      <TranslationLabel name='reservationBreakDown' />
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </>
  )
}
